
<template>
  <div class="container" style="margin-top: 1em;" v-if="['A'].find(el=>el==store.state.user.groupe)">
    <div class="raw">
      <div class="col-1"></div>
      <div class="col-11">
        <v-progress-linear v-if="store.state.waiting" color="antiquewhite" indeterminate></v-progress-linear>
        
        <v-row>
          <v-col cols="1" title="exporter un fichier Excel">
            <JsonToExcel  v-if="['A'].find(el=>el==store.state.user.groupe)" :type="type"></JsonToExcel>
          </v-col>
          <v-col cols="1">
            <v-btn density="compact" title="Mise à jour des données" v-if="['A'].find(el=>el==store.state.user.groupe)" @click="refreshPrices(store.state.etablissement,store.state.date)" color="primary">
              <v-icon icon="mdi-refresh"  ></v-icon>
            </v-btn>   
          </v-col>
          <v-col cols="1">
            <v-btn density="compact" title="Lancer l'import dans Y2" v-if="['A'].find(el=>el==store.state.user.groupe)" @click="importExport()" color="grey">
              <v-icon icon="mdi-database-export-outline"></v-icon>
            </v-btn>   
          </v-col>
          <v-col cols="1">
            <ButtonImport />
          </v-col>
          <v-col v-if="store.state.mode=='import'" cols="1">
            <v-btn density="compact" :loading="loading" @click="exportPromo()" color="red" prepend-icon="mdi-sale-outline"></v-btn> 
          </v-col>
          <v-col cols="1">
            <v-btn
              @click="filtreSpeedDial=!filtreSpeedDial"
              icon="mdi-filter-menu-outline"
              density="compact"
              color="orange"
              rounded="1"
              style="width: 64px;height: 24px;"
            > 
          </v-btn>
          </v-col>
          <v-col  v-for="type of tabSpeedDial" cols="1" style="margin-left: -20px;" v-if="filtreSpeedDial" >
              <v-speed-dial 
                v-model="fabSpeedDial[type]"
                location="bottom"
                transition="fade-transition"
              >
                <template v-slot:activator="{ props: activatorProps }">
                  <v-btn
                    v-bind="activatorProps"
                    density="compact"
                    rounded="1"
                    style="width: 70px;height: 24px;"
                  > {{ type }}
                </v-btn>
                </template> 
                
                  <v-btn v-for="(value,index) in store.state.subTypeMap[type]" :key="index" style="width: 64px;height: 24px;" @click="filterArticles(type,value);filtreSpeedDial=false">{{ value }}</v-btn>
              </v-speed-dial>
          </v-col>
          <v-col v-if="filtreSpeedDial" cols="1" style="margin-left: -20px;">
            <v-btn  icon="mdi-recycle" density="compact" @click="restaurerBackup();filtreSpeedDial=false" color="blue"
            > </v-btn>
          </v-col>
          
           
        </v-row>

       
        <div v-if="!hasData && !store.state.waiting" class="text-center pa-4">
          <v-alert type="info">Aucune donnée disponible</v-alert>
        </div>

        
        <div v-if="hasData">
          <div v-for="(marqueData, marqueKey) in paginatedArticles" :key="marqueKey">
            <div v-for="(themeData, themeKey) in marqueData" :key="themeKey">
              <h4 style="color:grey"> 
                {{ getThemeInfo(themeData).marque }} 
                | {{ getThemeInfo(themeData).theme }} 
              </h4> 
              <Theme :theme="themeData"></Theme>
              <br>
              <br>
            </div>
            
          </div>

          <v-divider ></v-divider>
          
          <v-row v-if="totalPages > 1">
            
            <v-col cols="auto" v-if="hasData">
             
              <v-speed-dial location="top center" transition="fade-transition" v-if="hasData">
                <template v-slot:activator="{ props: activatorProps }">
                  <v-fab
                    v-bind="activatorProps"
                    size="x-small"
                    icon="$vuetify"
                  >{{ store.state.itemsPerPage }}
                </v-fab>
                </template>
                
                <v-btn rounded="circle" 
                  v-for="(page,index) in [100, 200, 300, 400, 500]" :key="index"
                  @click="store.state.itemsPerPage=page">{{ page }}
                </v-btn>
              </v-speed-dial>
            </v-col>
            <v-col cols="auto">
              <v-pagination style="margin-top: -10px;"
                v-model="store.state.currentPage"
                :length="totalPages"
                :total-visible="7"
                rounded="circle"
                size="small"
                @update:model-value="scrollToTop"
              ></v-pagination>
            </v-col>
            <v-col cols="auto">
              <v-chip class="ml-2" size="small">

                {{ startIndex + 1 }} - {{ endIndex }} sur {{ totalItems }} articles
              </v-chip>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </div>

  <v-dialog v-model="store.state.progressDialog" width="auto">
    <v-progress-circular :model-value="cpt" :rotate="360" :size="100" :width="15" color="danger">
      <template v-slot:default>{{ cpt }} %</template>
    </v-progress-circular>
  </v-dialog>

  <div class="text-center pa-4">
    <v-dialog v-model="importDialog" width="600">
      <v-card title="Import Exopéra" width="600">
        <v-card-text>
          <h6>Les modifications de prix seront importés dans Exopéra à {{ getNextHalfHour() }}.</h6>
        </v-card-text>
        <template v-slot:actions>
          <v-btn class="ms-auto" text="Ok" @click="importDialog = false"></v-btn>
        </template>
      </v-card>
    </v-dialog>
  </div>
  <v-snackbar
    v-model="snackbar"
    :color="snackbarColor"
    timeout="2000"
    location="top"
  >
    {{ snackbarMessage }}
    <template v-slot:actions>
      <v-btn color="white" variant="text" @click="snackbar = false">
        Fermer
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup>
import Theme from './Theme.vue';
import axios from 'axios'
import { onMounted, ref, computed } from 'vue'
import store from './store'
import JsonToExcel from './JsonToExcel.vue';
import ButtonImport from '@/components/ButtonImport.vue'
let filtreSpeedDial=ref(false)
let cpt = ref(0)
let importDialog = ref(false)
// Variables de pagination
// let currentPage = ref(1)
// let itemsPerPage = ref(100)
const fabSpeedDial = ref({
  'promo': false,
  'stock': false,
  'collec': false,
  'couleur': false,
  'taille': false
})
const tabSpeedDial = ref([
  'promo',
  'stock',
  'collec',
  'couleur',
  'taille'
])
let type=ref('produits')
// Mapping des sous-types
const hasData = computed(() => {
  return store.state.articles && 
  typeof store.state.articles === 'object' && 
  Object.keys(store.state.articles).length > 0
})
// Convertir l'objet en tableau plat pour la pagination
const flattenedThemes = computed(() => {
  const items = []
  if (!hasData.value) return items
  try {
    // Parcourir l'objet articles
    for (const marqueKey in store.state.articles) {
      const marque = store.state.articles[marqueKey]
      if (marque && typeof marque === 'object') {
        for (const themeKey in marque) {
          const theme = marque[themeKey]
          if (theme && typeof theme === 'object') {
            for (const refKey in theme) {
              const reference = theme[refKey]
              if (reference && typeof reference === 'object') {
                for (const barcodeKey in reference) {
                  const article = reference[barcodeKey]
                  if (article) {
                    items.push({
                      marqueKey,
                      themeKey,
                      refKey,
                      barcodeKey,
                      data: article
                    })
                    // if (!subTypeMap.value.promo.find((el) => el === article.type_promo) && article.type_promo !== '') {
                    //     subTypeMap.value.promo.push(article.type_promo);
                    // }
                    // if(!subTypeMap.value.collec.find((el)=>el===article.collection) && article.collection!==''){
                    //   subTypeMap.value.collec.push(article.collection)
                    // }
                    // if(!subTypeMap.value.couleur.find((el)=>el===article.code_couleur) && article.code_couleur!==''){
                    //   subTypeMap.value.couleur.push(article.code_couleur)
                    // }
                    // if(article.taille && !subTypeMap.value.taille.find((el)=>el===article.taille) && article.taille!==''){
                    //   subTypeMap.value.taille.push(article.taille)
                    // }
                  }
                }
              }
            }
          }
        }
      }
    }
    // console.log(items);
    // console.log(subTypeMap.value)
  } catch (error) {
    console.error('Erreur lors de l\'aplatissement:', error)
  }
  
  return items
})

// Calculs de pagination
const totalItems = computed(() => flattenedThemes.value.length)
const totalPages = computed(() => Math.max(1, Math.ceil(totalItems.value / store.state.itemsPerPage)))
const startIndex = computed(() => (store.state.currentPage - 1) * store.state.itemsPerPage)
const endIndex = computed(() => Math.min(startIndex.value + store.state.itemsPerPage, totalItems.value))

// Éléments paginés (reconstruit la structure originale)
const paginatedArticles = computed(() => {
  if (!hasData.value || totalItems.value === 0) return {}
  
  const paginatedItems = flattenedThemes.value.slice(startIndex.value, endIndex.value)
  
  // Reconstruire la structure originale
  const result = {}
  
  for (const item of paginatedItems) {
    if (!result[item.marqueKey]) {
      result[item.marqueKey] = {}
    }
    if (!result[item.marqueKey][item.themeKey]) {
      result[item.marqueKey][item.themeKey] = {}
    }
    if (!result[item.marqueKey][item.themeKey][item.refKey]) {
      result[item.marqueKey][item.themeKey][item.refKey] = {}
    }
    result[item.marqueKey][item.themeKey][item.refKey][item.barcodeKey] = item.data
  }
  
  return result
})

// Fonction utilitaire pour extraire les infos d'un thème
const getThemeInfo = (themeData) => {
  try {
    if (!themeData) return { MARQUE: 'N/A', THEME: 'N/A' }
    // Prendre le premier article du thème pour obtenir les infos
    const firstRef = Object.values(themeData)[0]
    if (!firstRef) return { MARQUE: 'N/A', THEME: 'N/A' }
    const firstArticle = Object.values(firstRef)[0]
    if (!firstArticle) return { MARQUE: 'N/A', THEME: 'N/A' }
    return firstArticle
  } catch (error) {
    console.error('Erreur getThemeInfo:', error)
    return { MARQUE: 'N/A', THEME: 'N/A' }
  }
}

// Scroller en haut
const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

async function importExport() {
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/scheduledTasksY2',
    // url: 'http://localhost:8282/apimyedisac/scheduledTasksY2',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
    },
    data: {
      first: 2265,
      second: 24551,
      third: 3389,
      user: store.state.user
    }
  }

  return axios.request(config)
    .then((response) => { 
      if(response.data.statut == 'ok') {
        importDialog.value = true
      }
    })
    .catch((error) => {
      console.log(error);
    });
}
async function filterArticles(type,value){
      
    value=value.toLowerCase()
    // console.log(type,value);
    try {
        for (const marqueKey in store.state.articles) {
          for (const themeKey in store.state.articles[marqueKey]) {
              for (const refKey in store.state.articles[marqueKey][themeKey]) {
                for (const barKey in store.state.articles[marqueKey][themeKey][refKey]) {
                  if(type=='promo'){
                    if(value=='sans'&&store.state.articles[marqueKey][themeKey][refKey][barKey].prix_promo>0){
                      delete store.state.articles[marqueKey][themeKey][refKey][barKey]
                    }
                    else if(value!='sans'&&store.state.articles[marqueKey][themeKey][refKey][barKey].type_promo.toLowerCase()!=value.toLowerCase()){
                      delete store.state.articles[marqueKey][themeKey][refKey][barKey]
                    }
                  }
                  if(type=='stock'){
                    if(value=='sans'&&Object.values(store.state.articles[marqueKey][themeKey][refKey][barKey].stock).reduce((total, quantity) => total + quantity, 0)>0){
                      delete store.state.articles[marqueKey][themeKey][refKey][barKey]
                    }else if(value=='stock'&&Object.values(store.state.articles[marqueKey][themeKey][refKey][barKey].stock).reduce((total, quantity) => total + quantity, 0)<=0){
                      delete store.state.articles[marqueKey][themeKey][refKey][barKey]
                    }
                    // else
                    // if((!store.state.articles[marqueKey][themeKey][refKey][barKey].stock[value]||store.state.articles[marqueKey][themeKey][refKey][barKey].stock[value]<=0)){
                    //   delete store.state.articles[marqueKey][themeKey][refKey][barKey]
                    // }
                  }
                  if(type=='couleur'){
                    if(store.state.articles[marqueKey][themeKey][refKey][barKey].code_couleur.toLowerCase()!=value.toLowerCase()){
                      delete store.state.articles[marqueKey][themeKey][refKey][barKey]
                    }
                  }
                  if(type=='taille'){
                    if(store.state.articles[marqueKey][themeKey][refKey][barKey].taille.toLowerCase()!=value.toLowerCase()){
                      delete store.state.articles[marqueKey][themeKey][refKey][barKey]
                    }
                  }
                  if(type=='collec'){
                    if(store.state.articles[marqueKey][themeKey][refKey][barKey].collection.toLowerCase()!=value.toLowerCase()){
                      delete store.state.articles[marqueKey][themeKey][refKey][barKey]
                    }
                  }
                }
              }
          }
        }
    } catch (error) {
        console.error('Erreur de calcul du max:', error);
    }
  }
function getNextHalfHour(dateInput = new Date()) {
  const date = new Date(dateInput);
  let hours = date.getHours();
  const minutes = date.getMinutes();
  
  if (minutes >= 30) {
    hours = (hours + 1) % 24;
  }
  
  const formattedHours = hours.toString().padStart(2, '0');
  return `${formattedHours}h30`;
}

async function refreshPrices(etablissement, date) {
  if (!hasData.value) {
    console.warn('Pas de données à rafraîchir');
    return;
  }
  
  store.state.progressDialog = true
  
  // Calculer le nombre total d'articles
  let max = 0
  try {
    for (const marqueKey in store.state.articles) {
      for (const themeKey in store.state.articles[marqueKey]) {
        for (const refKey in store.state.articles[marqueKey][themeKey]) {
          max += Object.keys(store.state.articles[marqueKey][themeKey][refKey]).length
        }
      }
    }
  } catch (error) {
    console.error('Erreur de calcul du max:', error);
  }
  
  let i = 0            
  for (const marqueKey in store.state.articles) {
    for (const themeKey in store.state.articles[marqueKey]) {
      for (const refKey in store.state.articles[marqueKey][themeKey]) {
        for (const barcodeKey in store.state.articles[marqueKey][themeKey][refKey]) {
          cpt.value = Number((100 * (i / max)).toFixed(2))
          const reference = {}
          reference[refKey] = store.state.articles[marqueKey][themeKey][refKey][barcodeKey]
          await refreshPrice(reference, etablissement, date)
          await refreshStock(reference)
          i++
        }
      }
    }
  }
  store.state.progressDialog = false
}
const fabNested=ref(false)
async function getBarCodes(reference) {
  let barCodes = ''
  const refKey = Object.keys(reference)[0]
  if (refKey && reference[refKey]?.codebarre) {
    barCodes = `&barcodes=${reference[refKey].codebarre}`
  }
  return barCodes
}

async function refreshPrice(reference, etablissement, date) {
  if (!reference) return
  
  const referenceCol = reference[Object.keys(reference)[0]]
  if (!referenceCol) return
  
  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `/cegid-api/Y2/98661025_001_PROD/api/stores/${etablissement}/selling-prices/v1?taxExcluded=false&date=${date}${await getBarCodes(reference)}`,
    headers: { 
      'Authorization': `Bearer ${store.state.token_y2}`, 
      'Content-Type': 'application/json'
    }
  };
  
  axios.request(config)
    .then((response) => {
      if (!response.data?.prices) return
      
      for(let price in response.data.prices) {
        const priceData = response.data.prices[price]
        if (!priceData) continue
        
        if(priceData.unitPrice?.base != priceData.unitPrice?.current) {
          referenceCol.prix_promo = priceData.unitPrice.current.toFixed(1)
          referenceCol.type_promo = priceData.periodId
          referenceCol.vte_euro = priceData.unitPrice.base.toFixed(3)
        } else {
          referenceCol.prix_promo = 0
          referenceCol.type_promo = ''
          referenceCol.vte_euro = priceData.unitPrice.base.toFixed(3)
        }
      }
    })
    .catch((error) => {
      console.log(error);
    })  
}

async function refreshStock(reference) {
  if (!reference) return
  
  const referenceCol = reference[Object.keys(reference)[0]]
  if (!referenceCol) return
  
  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `/cegid-api/Y2/98661025_001_PROD/api/available-quantities/v1?${(await getBarCodes(reference)).substring(1)}`,
    headers: { 
      'Authorization': `Bearer ${store.state.token_y2}`, 
      'Content-Type': 'application/json'
    }
  };
  
  axios.request(config)
    .then((response) => {
      if (!response.data) return
      
      for(let barCode in response.data) {
        let articleStock = {}
        for(let stock in response.data[barCode]?.stores) {
          articleStock = {
            ...articleStock,
            [response.data[barCode].stores[stock].id]: response.data[barCode].stores[stock].physicalQty
          }
        }
        referenceCol.stock = articleStock
      }
    })
    .catch((error) => {
      console.log(error);
    })  
}
let articlesBackUp={}
// onMounted(()=>{
//   articlesBackUp=JSON.parse(JSON.stringify(store.state.articles))
// })
function restaurerBackup() {
    store.commit('addArticles',store.state.articlesBackUp) 
}
const snackbar = ref(false)
const snackbarMessage = ref('')
const snackbarColor = ref('success')
const showSnackbar = (message, color = 'success') => {
  snackbarMessage.value = message
  snackbarColor.value = color
  snackbar.value = true
}
let loading=ref(false)
async function exportPromo(){
    loading.value=true
    let data = {articles:{...store.state.articles},
          isChanged:{
          exportPromo:true
        },
        user:store.state.user
      }
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/articles',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
    },
    data : data
    }
    
    return axios.request(config)
    .then((response) => { 
      loading.value=false
      store.state.mode=''
      showSnackbar(`Export des soldes réussie !`, 'success')
      
    })
    .catch((error) => {
    });
  // }
}

// Fonction pour mettre à jour le backup (si besoin)
function mettreAJourBackup() {
    store.commit('setArticlesBackUp',store.state.articles);
}
</script>